import { useRef } from "react";
import { useIntl } from "react-intl";
import { Button } from "@/components/design/Button";
import { TextInput } from "@/components/design/TextField";
import type { ReferenceSearchState } from "./listing-reference";

// Das Suchfeld über den Listen der Ausschreibungen (Verwaltung und Bewerbende): genau eine Kennziffer,
// keine Volltextsuche. Was als Kennziffer gilt und was an genesis geht, steht in listing-reference.ts.
//
// Das Löschkreuz des Browsers bei `type="search"` gehört nicht zum Designsystem (in Chrome ein blaues
// Kreuz); es ist ausgeblendet, an seiner Stelle steht der Schließen-Knopf der App (`variant="icon"`).
export function ListingReferenceSearch({ search }: { search: ReferenceSearchState }) {
  const intl = useIntl();
  const input = useRef<HTMLInputElement>(null);
  return (
    <div className="relative max-w-64">
      <TextInput
        ref={input}
        type="search"
        value={search.term}
        onChange={(event) => search.setTerm(event.target.value)}
        aria-label={intl.formatMessage({
          id: "share.listings.referenceSearch.label",
          defaultMessage: "Nach Kennziffer suchen",
        })}
        placeholder={intl.formatMessage(
          { id: "share.listings.referenceSearch.placeholder", defaultMessage: "Kennziffer, z. B. {example}" },
          { example: `${new Date().getFullYear()}-0042` },
        )}
        className="[&::-webkit-search-cancel-button]:appearance-none"
      />
      {search.term ? (
        <Button
          variant="icon"
          size="sm"
          className="absolute right-1 top-1/2 -translate-y-1/2"
          aria-label={intl.formatMessage({
            id: "share.listings.referenceSearch.clear",
            defaultMessage: "Suche leeren",
          })}
          onClick={() => {
            search.setTerm("");
            input.current?.focus();
          }}
        >
          ✕
        </Button>
      ) : null}
    </div>
  );
}
